/* RESPONSIBLE TEAM: team-knowledge-foundations */

import { type SyncSourceWrapperResponse } from 'embercom/services/knowledge-hub-service';

export type KnowledgeUsageSummary = {
  [key: number]: {
    entity_type: number;
    all: number;
    agent: number;
    copilot: number;
    help_center: number;
    sync_sources: SyncSourceWrapperResponse[];
    is_eligible_for_copilot: boolean;
    is_eligible_for_chatbot: boolean;
  };
};

export type SyncSourceType =
  | 'notion'
  | 'guru'
  | 'confluence'
  | 'zendesk'
  | 'external_content'
  | 'zendesk_tickets'
  | 'salesforce_knowledge'
  | 'salesforce_cases'
  | 'box'
  | 'document360'
  | 'freshdesk'
  | 'freshdesk_tickets';

export enum CardStatus {
  LIVE = 'live',
  SYNCING = 'syncing',
  ERROR = 'error',
}

export type ContentFilter = 'all' | 'ai-agent' | 'ai-copilot' | 'help-center';
